import { Button, Space } from "antd";

import Light from "@Assets/icons/Light";
import TagStatus from "@Components/V2/TagStatus";
import { formatGender } from "@Utils/formatGender";
import { COLUMN_TYPE_RECOMMENDATION } from "../../Constants";
import React from "react";
import QueueNumber from "../QueueNumber";
import { formatRecommendedArrival } from "../../../../../../utils/recommendedArrival";

const QueueTableColumn = ({
  type = COLUMN_TYPE_RECOMMENDATION.DEFAULT,
  onClickDetail,
  onClickEmergency,
  onClickAddQueue,
  passedProgressById = {},
  passedThreshold,
}) => {
  return [
    {
      title: "No Antri",
      dataIndex: "queue_number",
      key: "queue_number",
      width: 150,
      isShow: true,
      render: (text, record) => (
        <QueueNumber
          text={text}
          isAdminRecommended={record?.is_passed}
          passedProgress={
            record?.queues_passed_count ?? passedProgressById[record?.id]
          }
          passedThreshold={passedThreshold}
        />
      ),
    },
    {
      title: "Nama",
      dataIndex: ["child", "fullname"],
      key: "child.fullname",
      width: 300,
      isShow: true,
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "Umur",
      dataIndex: ["child", "age"],
      key: "child.age",
      width: 100,
      isShow: true,
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "Status",
      dataIndex: ["queue_status", "name"],
      key: "queue_status.name",
      width: 150,
      isShow: true,
      render: (text) => <TagStatus text={text} />,
    },
    {
      title: "Rekomendasi Waktu",
      dataIndex: "recommended_arrival_time",
      key: "recommended_arrival_time",
      width: 180,
      isShow: true,
      render: (text) => <span>{formatRecommendedArrival(text)}</span>,
    },
    {
      title: "Jenis Kelamin",
      dataIndex: ["child", "gender"],
      key: "child.gender",
      width: 150,
      isShow: true,
      render: (text) => <span>{formatGender(text)}</span>,
    },
    {
      title: "Aksi",
      key: "aksi",
      width: 150,
      fixed: "right",
      isShow: type === COLUMN_TYPE_RECOMMENDATION.DEFAULT,
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            size="large"
            onClick={() => onClickDetail(record)}
          >
            Detail
          </Button>
          <Button
            type="primary"
            danger
            icon={<Light />}
            size="large"
            onClick={() => onClickEmergency(record)}
            style={{ display: "flex", gap: 6, alignItems: "center" }}
          >
            Darurat
          </Button>
        </Space>
      ),
    },
    {
      title: "Aksi",
      key: "aksi",
      width: 150,
      fixed: "right",
      isShow: type === COLUMN_TYPE_RECOMMENDATION.DRAWER,
      render: (_, record) => (
        <Button
          type="primary"
          ghost
          onClick={() => onClickAddQueue(record?.id)}
        >
          + Antrian
        </Button>
      ),
    },
  ].filter((item) => item.isShow);
};

export default QueueTableColumn;
